module.exports = __webpack_public_path__ + "static/media/numpy.9d25edd4.jpg";